import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import { BsArrowUpRight } from 'react-icons/bs';

import { makeAuthorPath } from '../../paths';
import { SectionHeader } from './SectionHeader';

const FEATURED_AUTHOR_SLUGS = [
  'eliza',
  'jack',
  'kat',
  'vivian',
  'bec',
  'kayleigh',
];

export function AuthorPill({ author }) {
  return (
    <Link
      to={makeAuthorPath(author.slug, 1)}
      className="flex items-center bg-white w-80 p-4 rounded-full"
    >
      <div
        style={{
          backgroundImage: `url(https://img.paperform.co/fetch/w_120,h_120/${author.profile_image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        className="w-16 h-16 rounded-full -m-2 mr-1 -ml-[7px]"
      />
      <div className="flex-1 overflow-hidden px-2 min-w-0">
        <p className="text-base m-0 ml-1 truncate text-black opacity-70">
          {author.name}
        </p>
      </div>

      <div className="flex justify-center items-center bg-stone rounded-full w-12 h-12">
        <BsArrowUpRight color="black" />
      </div>
    </Link>
  );
}

export function FeaturedAuthors() {
  const {
    allGhostAuthor: { edges: allAuthors },
  } = useStaticQuery(graphql`
    query featuredAuthors($authorSlugs: [String]) {
      allGhostAuthor(filter: { slug: { in: $authorSlugs } }) {
        edges {
          node {
            name
            id
            slug
            profile_image
          }
        }
      }
    }
  `);

  const featuredAuthors = allAuthors.filter(({ node }) =>
    FEATURED_AUTHOR_SLUGS.includes(node.slug),
  );

  return (
    <>
      <SectionHeader label="Featured Authors" />
      <div className="flex gap-8 flex-wrap justify-center">
        {featuredAuthors.map(({ node: author }, i) => (
          <AuthorPill key={i} author={author} />
        ))}
      </div>
    </>
  );
}
